class FooterAccordion extends HTMLElement {
  constructor() {
    super();
    this.items = [];
    this.activeIndex = null;
    this.controller = new AbortController();
    this.mobileQuery = window.matchMedia('(max-width: 767px)');
  }

  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('[data-accordion-item]'));

    this.items.forEach((item, index) => {
      const trigger = item.querySelector('[data-accordion-trigger]');
      if (trigger) {
        trigger.addEventListener('click', () => this.toggle(index), {
          signal: this.controller.signal,
        });
      }
    });

    this.mobileQuery.addEventListener(
      'change',
      () => this.onBreakpointChange(),
      { signal: this.controller.signal }
    );
  }

  disconnectedCallback() {
    this.controller.abort();
  }

  onBreakpointChange() {
    if (!this.mobileQuery.matches) {
      this.items.forEach((item) => {
        const content = item.querySelector('[data-accordion-content]');
        const icon = item.querySelector('[data-accordion-icon]');
        if (content) content.style.maxHeight = '';
        if (icon) icon.classList.remove('rotate-90');
        const trigger = item.querySelector('[data-accordion-trigger]');
        trigger?.setAttribute('aria-expanded', 'false');
      });
      this.activeIndex = null;
    }
  }

  toggle(index) {
    if (!this.mobileQuery.matches) return;

    const item = this.items[index];
    const content = item.querySelector('[data-accordion-content]');
    const icon = item.querySelector('[data-accordion-icon]');
    const trigger = item.querySelector('[data-accordion-trigger]');
    const isOpen = this.activeIndex === index;

    // Close all items first
    this.items.forEach((otherItem, otherIndex) => {
      if (otherIndex !== index) {
        const otherContent = otherItem.querySelector(
          '[data-accordion-content]'
        );
        const otherIcon = otherItem.querySelector('[data-accordion-icon]');
        if (otherContent) otherContent.style.maxHeight = '0';
        if (otherIcon) otherIcon.classList.remove('rotate-90');
        const otherTrigger = otherItem.querySelector(
          '[data-accordion-trigger]'
        );
        otherTrigger?.setAttribute('aria-expanded', 'false');
      }
    });

    // Toggle current item
    if (isOpen) {
      content.style.maxHeight = '0';
      icon?.classList.remove('rotate-90');
      trigger?.setAttribute('aria-expanded', 'false');
      this.activeIndex = null;
    } else {
      content.style.maxHeight = content.scrollHeight + 'px';
      icon?.classList.add('rotate-90');
      this.activeIndex = index;
      trigger?.setAttribute('aria-expanded', 'true');
    }
  }
}

if (!customElements.get('footer-accordion')) {
  customElements.define('footer-accordion', FooterAccordion);
}
